import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

/**
 * Centered loading spinner that fills its container (route pending states,
 * list loads).
 *
 * ENG-1459: this owns the `role="status"` and its label. The `Spinner`
 * primitive carries a `role="status"` and a hardcoded English
 * `aria-label="Loading"` of its own, so nesting it inside another status
 * region produced two — which `getByRole('status')` reports as ambiguous and
 * axe flags as well. The icon is decorative here; the region is labelled once,
 * by whoever knows what is actually loading.
 */
export function CenteredSpinner({
  label,
  className,
}: {
  /** Announced by screen readers. Pass a translated string. */
  label?: string;
  className?: string;
}) {
  return (
    <div
      className={cn('flex h-full items-center justify-center', className)}
      role="status"
      aria-label={label}
    >
      <Spinner
        className="size-5 text-muted-foreground"
        role={undefined}
        aria-hidden
      />
    </div>
  );
}
